<template>
    <div class="box _gradient-bar">
        <div class="loading-spinner-outer" v-if="loading_tender">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Loading Tender, please wait
                </div>
            </div>
        </div>
        <div class="loading-spinner-outer" v-if="downloading_document">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Downloading Document, please wait
                </div>
            </div>
        </div>
        <div class="loading-spinner-outer" v-if="saving">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Saving, please wait
                </div>
            </div>
        </div>
        <div class="box-content">
            <div class="black-ice-page-tender-detail">
                <template v-if="!loading_tender">
                    <div class="tender-title">
                        <div class="title">
                            <h3 class="txt-primary mt-0">
                                {{ tender.TenderName }}
                            </h3>
                        </div>
                        <div class="date">
                            <div>
                                <strong>
                                    Entered Date:
                                </strong>
                                <span>
                                    {{ tender.EnteredDate }}
                                </span>
                            </div>
                            <div>
                                <strong>
                                    Deadline Date:
                                </strong>
                                <span>
                                    {{ tender.DeadlineDate }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="rows">
                        <div class="top-row">
                            <div class="left">
                                <div class="row-item">
                                    <div>
                                        <strong>
                                            Client Name:
                                        </strong>
                                        <span>
                                            {{ tender.ClientName }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-row">
                            <div class="row-item _description">
                                <div>
                                    <strong>Description</strong>
                                    <div v-html="tender.TenderDescription">
                                    </div>
                                </div>
                            </div>
                            <div class="row-item _statuses">
                                <div class="form-group">
                                    <label>
                                        <strong>
                                            Tendered
                                        </strong>
                                    </label>
                                    <div>
                                        <template v-if="tender.Tendered === 'Unknown'">
                                            <select class="form-control _sm" v-model="tender.Tendered" @change="updateTenderStatus" style="max-width: 150px;">
                                                <option value="Unknown" disabled>Unknown</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </select>
                                        </template>
                                        <template v-else>
                                            {{ tender.Tendered }}
                                        </template>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>
                                        <strong>
                                            Priced
                                        </strong>
                                    </label>
                                    <div>
                                        <template v-if="tender.Priced === 'Unknown'">
                                            <select class="form-control _sm" v-model="tender.Priced" @change="updateTenderPricedStatus" style="max-width: 150px;">
                                                <option value="Unknown" disabled>Unknown</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </select>
                                        </template>
                                        <template v-else>
                                            {{ tender.Priced }}
                                        </template>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>
                                        <strong>
                                            Project Complete
                                        </strong>
                                    </label>
                                    <div>
                                        <template v-if="tender.ProjectComplete === 'Unknown'">
                                            <select class="form-control _sm" v-model="tender.ProjectComplete" @change="updateTenderCompleteStatus" style="max-width: 150px;">
                                                <option value="Unknown" disabled>Unknown</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </select>
                                        </template>
                                        <template v-else>
                                            {{ tender.ProjectComplete }}
                                        </template>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>
                                        <strong>
                                            Project Won Lost
                                        </strong>
                                    </label>
                                    <div>
                                        <template v-if="tender.ProjectWonLost === 'Unknown'">
                                            <select class="form-control _sm" v-model="tender.ProjectWonLost" @change="updateTenderWonLostStatus" style="max-width: 150px;">
                                                <option value="Unknown" disabled>Unknown</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </select>
                                        </template>
                                        <template v-else>
                                            {{ tender.ProjectWonLost }}
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tender-documents" v-if="tender.Documents.length > 0 && tender.Documents[0].DocumentRecords !== 0">
                        <a class="tender-document cursor-pointer" v-for="document in tender.Documents" target="_blank" :href="`/commercial/black-ice-api/getTenderDocument?tender_id=${tender_id}&document_id=${document.DocumentLinkID}&document_name=${document.DocumentName}`" :data-filename="document.DocumentName">
                            <div class="icon">
                                <i class="fal fa-paperclip"></i>
                            </div>
                            <div class="filename">
                                    {{ document.DocumentName }}
                            </div>
                        </a>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: [
      'logged_in_user',
      'tender_id',
    ],
    data() {
      return {
        tender: {},
        loading_tender: true,
        downloading_document: false,
        saving: false,
        // portal_user_id: 75932,
      };
    },
    mounted() {
      this.loadTender();
    },
    methods: {
      loadTender() {
        this.loading_tender = true;
        axios.post('/commercial/black-ice-api/getTenderDetail', {
          tender_id: this.tender_id,
          // portal_user_id: this.portal_user_id,
        }).then((response) => {

          gtag('event', 'tender_detail_viewed', {
            'event_category': 'commercial_tenders',
            'event_label': 'Tender detail viewed',
            'value': this.tender_id,
          });

          this.tender = response.data;
          this.loading_tender = false;
        });
      },
      downloadDocument(document_id) {
        this.downloading_document = true;
        axios.post('/commercial/black-ice-api/getTenderDocument', {
          tender_id: Number(this.tender_id),
          document_id: Number(document_id),
        }).then((response) => {
          // window.location.href = response.data;

          gtag('event', 'tender_document_downloaded', {
            'event_category': 'commercial_tenders',
            'event_label': 'Tender document downloaded',
            'value': 'Tender document downloaded',
          });

          this.downloading_document = false;
        });
      },
      updateTenderStatus($event) {
        Swal.fire({
          title: 'Are you sure you want to update this tenders status?',
          text: 'You will not be able to update the status again.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Confirm',
        }).then((result) => {
          if (result.isConfirmed) {
            this.saving = true;
            axios.post('/commercial/black-ice-api/updateTenderStatus', {
              tender_id: Number(this.tender_id),
              // portal_user_id: this.portal_user_id,
              status: $event.target.value.toLowerCase(),
            }).then((response) => {

              gtag('event', 'tender_status_updated', {
                'event_category': 'commercial_tenders',
                'event_label': 'Tender status updated',
                'value': 'Tender status updated',
              });

              this.saving = false;
              Swal.fire({
                title: 'Status Updated',
                icon: 'success',
              });
            });
          } else {
            this.tender.Tendered = 'Unknown';
          }
        });
      },
      updateTenderPricedStatus($event) {
        Swal.fire({
          title: 'Are you sure you want to update this tenders priced status?',
          text: 'You will not be able to update the status again.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Confirm',
        }).then((result) => {
          if (result.isConfirmed) {
            this.saving = true;
            axios.post('/commercial/black-ice-api/updateTenderPricedStatus', {
              tender_id: Number(this.tender_id),
              // portal_user_id: this.portal_user_id,
              status: $event.target.value.toLowerCase(),
            }).then((response) => {

              gtag('event', 'tender_priced_status_updated', {
                'event_category': 'commercial_tenders',
                'event_label': 'Tender priced status updated',
                'value': 'Tender priced status updated',
              });

              this.saving = false;
              Swal.fire({
                title: 'Priced Status Updated',
                icon: 'success',
              });
            });
          } else {
            this.tender.Priced = 'Unknown';
          }
        });
      },
      updateTenderWonLostStatus($event) {
        Swal.fire({
          title: 'Are you sure you want to update this tenders won lost status?',
          text: 'You will not be able to update the status again.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Confirm',
        }).then((result) => {
          if (result.isConfirmed) {
            this.saving = true;
            axios.post('/commercial/black-ice-api/updateTenderWonLostStatus', {
              tender_id: Number(this.tender_id),
              // portal_user_id: this.portal_user_id,
              status: $event.target.value.toLowerCase(),
            }).then((response) => {

              gtag('event', 'tender_won_lost_status_updated', {
                'event_category': 'commercial_tenders',
                'event_label': 'Tender won lost status updated',
                'value': 'Tender won lost status updated',
              });

              this.saving = false;
              Swal.fire({
                title: 'Won Lost Status Updated',
                icon: 'success',
              });
            });
          } else {
            this.tender.ProjectWonLost = 'Unknown';
          }
        });
      },
      updateTenderCompleteStatus($event) {
        Swal.fire({
          title: 'Are you sure you want to update this tenders completed status?',
          text: 'You will not be able to update the status again.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Confirm',
        }).then((result) => {
          if (result.isConfirmed) {
            this.saving = true;
            axios.post('/commercial/black-ice-api/updateTenderCompleteStatus', {
              tender_id: Number(this.tender_id),
              // portal_user_id: this.portal_user_id,
              status: $event.target.value.toLowerCase(),
            }).then((response) => {

              gtag('event', 'tender_complete_status_updated', {
                'event_category': 'commercial_tenders',
                'event_label': 'Tender complete status updated',
                'value': 'Tender complete status updated',
              });

              this.saving = false;
              Swal.fire({
                title: 'Completed Status Updated',
                icon: 'success',
              });
            });
          } else {
            this.tender.ProjectComplete = 'Unknown';
          }
        });
      },
    },
  };
</script>
